import * as React from "react";
import styled from "styled-components";
import * as colors from "../settings/colors";

const EmptyMessageWrapper = styled.div`
  color: ${colors.TEXT_SECONDARY};
  font-size: 18px;
  font-weight: 600;
  text-align: center;
  padding: 40px;
`;

const EmptyMessage = props => <EmptyMessageWrapper {...props} />;

export default EmptyMessage;



// WEBPACK FOOTER //
// ./src/components/EmptyMessage.js